<template>
    <div>
        <buttonlist @help="help" @save="save"  ref="SetBtn"></buttonlist>
        <el-card class="box-card" style="padding-bottom:1px">
            <div style="line-height: 10px;">
                {{ $t('getapi[2292]') }}:
                <el-input
                        v-model="order.exclusively_id"
                        :placeholder="$t('getapi[2292]')"
                        style="width: 150px"
                        readonly
                        size="mini"
                >
                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThing"></i>
                </el-input>
                {{ $t('getapi[2291]') }}:
                <el-input size="mini" v-model="order.customer_order" type="text" style="width: 150px;"
                          disabled></el-input>
                {{ $t('getapi[2289]') }}:
                <el-input size="mini" v-model="order.delivery_person" type="text" style="width: 150px;"
                          disabled></el-input>
                {{ $t('getapi[2290]') }}:
                <el-input size="mini" v-model="order.delivery_date" type="text" style="width: 150px;"
                          disabled></el-input>
                <br/>
                <br/>
                {{ $t('getapi[3047]') }}:
                <el-input size="mini" v-model="order.consignment_flag" type="text" style="width: 150px;"
                          disabled></el-input>
                {{ $t('getapi[2283]') }}:
                <el-input size="mini" v-model="order.container_no" type="text" style="width: 150px;"
                          :disabled="order.issue_part_flow!=1"></el-input>
                <el-checkbox disabled v-model="order.issue_part_flow" :true-label=1 :false-label=0 style="margin-left: 8px">生成发出物流</el-checkbox>
                <!--{{ $t('getapi[2284]') }}:
                <el-input size="mini" v-model="order.issue_part_flow" type="text" style="width: 150px;"
                          disabled></el-input>-->
            </div>
        </el-card>
        <!-- <el-card class="box-card" style="padding-bottom:10px"> -->
            <!-- 表格 -->
            <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="明细" name="0">
                    <el-table
                            :data="datajson"
                            v-loading="loading"
                            :highlight-current-row="false"
                            show-overflow-tooltip="true"
                            border
                            stripe
                            size="mini"
                            :height="tableHeight"
                            tab-click="selectInfo(0)"
                            header-row-class-name="headerclass"
                            :row-class-name="tableRowClassName"
                            style="width: 100%; margin-top:0px"
                    >
                        <!-- <el-table-column type="selection" ></el-table-column> -->
                        <el-table-column show-overflow-tooltip prop="order_no" label="ID" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[2239]')"
                                         align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="qty_on_hand" :label="$t('getapi[2240]')"
                                         align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="cargo_position"
                                         :label="$t('getapi[1842]')"></el-table-column>
                        <!--<el-table-column show-overflow-tooltip prop="assign_qty" :label="$t('getapi[2241]')" align="right"
                                         width="120px"></el-table-column>-->
                        <el-table-column show-overflow-tooltip prop="sninvqty" :label="$t('getapi[2242]')"
                                         align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_qty" :label="$t('getapi[2207]')" width="120px"
                                         align="right">
                            <template slot-scope="scope">
                                <!--<el-input class="mcolor" v-if="scope.row.flag == false && qtyreadonly == false" v-model="scope.row.trans_qty" type="number" autocomplete="off" title=""  :disabled="qtyreadonly" @mousewheel.native.prevent size="mini"></el-input>-->
                                <el-input v-if="scope.row.flag == false" class="mcolor" v-model="scope.row.trans_qty" type="number"  autocomplete="off" title="" :disabled="qtyreadonly" @mousewheel.native.prevent size="mini"></el-input>
                                <el-input v-if="scope.row.flag == true" v-model="scope.row.trans_qty" type="number" autocomplete="off" title=""  :disabled="qtyreadonly" @mousewheel.native.prevent size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="measureunit" :label="$t('getapi[888]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_cost" :label="$t('getapi[2248]')"
                                         align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="field" :label="$t('getapi[115]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="co_line_id" :label="$t('getapi[2286]')"
                                         width="120px"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="co_line_no" :label="$t('getapi[1740]')" width="120px"
                                         align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="pnid" :label="$t('getapi[2287]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="pn_line_no" :label="$t('getapi[2288]')" width="120px"
                                         align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="is_audit" :label="$t('getapi[2249]')" width="120px">
                            <template slot-scope="scope">
                                <block v-if="scope.row.is_audit==0">{{$t('getapi[2411]')}}</block>
                                <block v-if="scope.row.is_audit==1">{{$t('getapi[2408]')}}</block>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_code"
                                         :label="$t('getapi[2250]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="direction" :label="$t('getapi[2251]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="original_order_no" :label="$t('getapi[2252]')"
                                         width="120px"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="original_line_no" :label="$t('getapi[2253]')"
                                         width="120px"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.remark"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="operation_person"
                                         :label="$t('getapi[346]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="trans_time" :label="$t('getapi[2254]')"
                                         width="120px"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="receive_time" :label="$t('getapi[4742]')"
                                         width="120px"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="expiry_date" :label="$t('getapi[225]')"
                                         width="120px"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="itemvernum" :label="$t('getapi[6700]')"
                                         width="150px"></el-table-column>
                        <!-- <el-table-column show-overflow-tooltip fixed="right" :label="$t('basic.edit')" width="70" align="center">
                            <template slot-scope="scope">
                                <el-button @click.native.prevent="edit(scope)" type="text" size="small">{{ $t('getapi[34]') }}</el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[8614]')" name="1">
                    <el-button type="primary" size="mini" @click.native.prevent="match">{{$t('getapi[8616]')}}
                    </el-button>
                    <el-table
                            :data="datamatch"
                            v-loading="loading"
                            :highlight-current-row="false"
                            show-overflow-tooltip="true"
                            border
                            size="mini"
                            :height="tableHeight"
                            :row-class-name="tableRowClassName1"
                            header-row-class-name="headerclass"
                            style="width: 100%; margin-top:0px">
                        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="200"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')" width="150"></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <!-- 表格 -->
            <!-- 分页 -->
            <!--<el-row>
                <el-col :span="16">
                    <el-pagination
                            style="margin-top: 1em"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="SelectIndexs"
                            :page-sizes="[100, 200, 300, 400]"
                            :page-size="100"
                            :pager-count="5"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                    ></el-pagination>
                </el-col>
                <el-col :span="8">
                    <div style="text-align: right;line-height: 50px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames
                        }}
                    </div>
                </el-col>
            </el-row>-->
        <!-- </el-card> -->
        <!-- 发料单弹框 -->
        <!--<pickred :isVisible="false" @getitembomp="getitembomp" ref="input"></pickred>-->
        <selector :isVisible="false" :isSplitPage=true :postUrl="'Inv/Action/GetSalOutOrderPopupList'"
                  @callback="getitembomp" ref="input"></selector>
    </div>
</template>

<script>
    export default {
        name: 'salsend',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-250
            }
        },
        data() {
            return {
                activeName: '0',
                DbTbNames: '', //表名
                datajson: [],
                datajsons: [],
                PageIndex: 1,
                PageSize: 100,
                SelectIndex: 1,
                SelectIndexs: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                order: {}, //发料单
                newitme: {
                    order_no: '',
                    consignment_flag: '',
                    lastedittime: '',
                    negative_flag: true,
                    Lists: [
                        {
                            order_no: '',
                            line_no: 0,
                            partid: 0,
                            part_code: '',
                            part_version: '',
                            part_name: '',
                            measureunit: '',
                            assist_measureunit: '',
                            cargo_position: '',
                            qty_on_hand: 0,
                            assign_qty: 0,
                            plan_qty: 0,
                            assistqty_on_hand: 0,
                            assist_plan_qty: 0,
                            field: 0,
                            operation_code: '',
                            direction: '',
                            is_audit: 0,
                            workproc_id: '',
                            workproc_name: '',
                            onhandid: 0,
                            batch_no: '',
                            sequence_no: '',
                            part_cost: 0,
                            master_assist_rate: 0,
                            trans_qty: 0,
                            assist_trans_qty: 0,
                            receive_time: '',
                            expiry_date: '',
                            operation_person: '',
                            trans_time: '',
                            original_order_no: '',
                            original_line_no: '',
                            remark: ''
                        }
                    ]
                },
                datamatch: [],
                qtyreadonly:false,
            };
        },
        mounted: function () {
            this.$refs.SetBtn.SetButtonEnable('');
            if(this.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                this.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            console.log('构建' + this.order.exclusively_id)
            /*console.log(this.$route);
            this.order.exclusively_id = this.$route.query.code;
            this.order.consignment_flag =  this.$route.query.consignment_flag;
            this.order.customer_order=this.$route.query.customer_order;
            this.order.delivery_person=this.$route.query.delivery_person;
            this.order.concurrent_time=this.$route.query.concurrent_time;
            this.order.negative_flag=this.$route.query.negative_flag;
            this.order.issue_part_flow=this.$route.query.issue_part_flow;*/
        },
        /*watch: {
            $route: function(e) {
                console.log(e);
                let quer = e.query;
                if(quer.code){
                    this.order.exclusively_id = quer.code;
                    this.order.consignment_flag = quer.consignment_flag;
                    this.order.customer_order=quer.customer_order;
                    this.order.delivery_person=quer.delivery_person;
                    this.order.concurrent_time=quer.concurrent_time;
                    this.order.negative_flag=quer.negative_flag;
                    this.order.issue_part_flow=quer.issue_part_flow;
                    this.initdata();
                }
            }
        },*/
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'salshipmentslist' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    if (data.code) {
                        vm.order.exclusively_id = data.code;
                        vm.order.consignment_flag = data.consignment_flag;
                        vm.order.customer_order = data.customer_order;
                        vm.order.delivery_person = data.delivery_person;
                        vm.order.concurrent_time = data.concurrent_time;
                        vm.order.negative_flag = data.negative_flag;
                        vm.order.issue_part_flow = data.issue_part_flow;
                        vm.initdata();
                    }
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        beforeDestroy() {
            removeEventListener('paste', this.keyPaste);
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name);
            },
            //表格背景
            tableRowClassName({row, rowIndex}) {
                if (row.enable_flag == '是') {
                    return 'warning-row';
                }
                if (row.version_status == '不可用') {
                    return 'dark-row';
                }
            },
            tableRowClassName1({row, rowIndex}){
                if(row.remark == '未匹配'){
                    return 'red'
                }
                if(row.remark == '已匹配'){
                    return 'green'
                }
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.initdata();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.initdata();
            },
            //打开弹框
            doTheThing() {
                this.$refs.input.clearInput(true);
            },
            //获取发料单信息
            getitembomp(e) {
                console.log(e);
                this.order = e;
                this.initdata();
            },
            // 刷新
            reflash() {
                this.initdata();
            },
            //获取信息
            initdata() {
                let that = this;
                that.datajson = [];
                that.datajsons = [];
                let parm = {
                    order_no: that.order.exclusively_id,
                    consignment_flag: that.order.consignment_flag
                };
                that.$http.urlpost('Inv/Action/GetSalOutActionBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.newitme.Lists = res.DataContent.Lists;
                        that.datajson = res.DataContent.Lists;
                        if(that.datajson.length > 0){
                            // 按照物料拆分数组
                            let map = {},
                                dest = []
                            for(let i=0;i<that.datajson.length;i++){
                                let ai = that.datajson[i]
                                if(!map[ai.part_code + ai.line_no]){
                                    dest.push({
                                        part_code: ai.part_code,
                                        line_no: ai.line_no,
                                        data: [ai],
                                        flag: true
                                    })
                                    map[ai.part_code+ ai.line_no] = ai
                                } else {
                                    for(let j=0;j<dest.length;j++){
                                        let dj = dest[j]
                                        if(dj.part_code == ai.part_code && dj.line_no == ai.line_no){
                                            dj.data.push(ai)
                                        }
                                    }
                                }
                            }
                            // 计算各数组出库数量之和是否等于预发数
                            //console.log('dest' + JSON.stringify(dest))
                            for(let i = 0;i<dest.length;i++){
                                let sum = 0
                                for(let j=0;j<dest[i].data.length;j++){
                                    sum = sum + (that.$limits.fnIsEmpty(dest[i].data[j].trans_qty)?0:dest[i].data[j].trans_qty)
                                }
                                if(dest[i].data[0].sninvqty != sum){
                                    dest[i].flag = false
                                } else {
                                    dest[i].flag = true
                                }
                            }
                            //
                            for(let i = 0;i<that.datajson.length;i++){
                                that.datajson[i].flag = true
                            }
                            for(let i = 0;i<dest.length;i++){
                                if(dest[i].flag == false){
                                    for(let j=0;j<that.datajson.length;j++){
                                        if(that.datajson[j].part_code == dest[i].part_code){
                                            that.datajson[j].flag = false
                                        }
                                    }
                                }
                            }

                            //console.log(that.datajson)
                        }
                        if (!that.$limits.fnIsEmpty(that.order.exclusively_id)) {
                            that.$refs.SetBtn.SetButtonEnable('save');
                        }
                        else{
                            that.$refs.SetBtn.SetButtonEnable('');
                        }
                    }
                });
            },
            //执行保存
            save() {
                let that = this;
                let parm = {
                    Lists: [],
                    order_no: '',
                    consignment_flag: '',
                    lastedittime: '',
                    negative_flag: '',
                    LangType: that.$processdata.getLang(),
                };
                parm.order_no = that.order.exclusively_id;
                parm.consignment_flag = that.order.consignment_flag;
                parm.lastedittime = that.order.concurrent_time;
                parm.negative_flag = that.order.negative_flag;
                parm.issue_part_flow = that.order.issue_part_flow;
                parm.container_no = that.order.container_no;
                that.datajson.forEach(item => {
                    parm.Lists.push(item);
                })
                // that.datajsons.forEach(item=>{
                // 	parm.Lists.push(item);
                // })
                console.log(JSON.stringify(parm));
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('Inv/Action/SaveSalOutData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        // that.initdata();
                        that.$refs.SetBtn.SetButtonEnable('');
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });
            },

            //切换
            handleClick(tab,event){
                let that = this
                that.activeName = tab.name
                if(tab.name == 0){
                    window.removeEventListener('paste', this.keyPaste)
                } else if(tab.name == 1){
                    window.addEventListener('paste', this.keyPaste)
                }
            },
            keyPaste(e) {
                let that = this;
                if(this.$route.name == this.$options.name){
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.check(data);
                        }
                    }
                }
            },
            check(datap) {
                let that = this
                console.log(JSON.stringify(datap))
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                console.log('arr' + arr)
                that.datamatcht = []
                for (let i = 0; i < arr.length - 1; i++) {
                    that.datamatch = [...that.datamatch, {
                        part_code: arr[i].split('\\t')[0],
                        sequence_no: arr[i].split('\\t')[1],
                        remark: ''
                    }]
                }
            },
            match(){
                let that = this
                /*that.activeName = '0'*/
                for(let i = 0;i<that.datamatch.length;i++){
                    that.datamatch[i].remark = '未匹配'
                    
                    for(let j = 0;j<that.datajson.length;j++){
                        if(that.datajson[j].part_code == that.datamatch[i].part_code && that.datajson[j].sequence_no == that.datamatch[i].sequence_no){
                            that.datajson[j].trans_qty = 1
                            that.datamatch[i].remark = '已匹配'
                        }
                    }

                    that.qtyreadonly=true;
                }
            }
        }
    };
</script>

<style scoped lang="less">
    /deep/ .red {
        background: #ff7879;
    }
    /deep/ .green {
        background: #c8ffbb;
    }
</style>
